import React from 'react';
import Popover from 'components/shared/popover';
import ScrollableContainer from 'components/shared/scrollable';
import { pluralize } from 'utils/string_utils';
import { Icon } from 'ui';
import Link from 'components/_shared/Link.js';

class IndexQuickLook extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState(state => ({
      isActive: !state.isActive,
    }));
  }

  handleItemClick(arg) {
    this.toggleMenu();
    this.props.onItemClick(arg);
  }

  render() {
    const { data, description, label, icon, valueKey, onItemClick } =
      this.props;
    return (
      <div className="IndexQuickLook">
        <span
          className="IndexQuickLook-count"
          onClick={this.toggleMenu}
          role="button"
          tabIndex="0"
          onKeyDown={e => e.key === 'Enter' && this.toggleMenu()}
        >
          {!!icon && <Icon className="IndexQuickLook-icon" name={icon} />}
          {data.length} {pluralize(data.length, label.singular, label.plural)}
        </span>
        {this.state.isActive && (
          <Popover dismissCallback={this.toggleMenu} autoPosition>
            {!!description && (
              <div className="IndexQuickLook-description">
                <span
                  ref={node => node && $clamp(node, { clamp: 3 })}
                  children={description}
                />
                <hr />
              </div>
            )}
            <ScrollableContainer>
              {data.map(item => (
                <Link
                  if={!onItemClick}
                  href={item.url}
                  target="blank"
                  className="NewPopoverOption undecorated"
                  onClick={() => this.handleItemClick(item.id)}
                  tabIndex="0"
                  onKeyDown={e =>
                    e.key === 'Enter' && this.handleItemClick(item.id)
                  }
                  children={item[valueKey]}
                  key={item.id}
                  forceClick
                />
              ))}
            </ScrollableContainer>
          </Popover>
        )}
      </div>
    );
  }
}

export default IndexQuickLook;
